module.exports = __webpack_public_path__ + "static/media/smoothie_paper_straw3.fa08488f.png";